export const FOCUS_SELECTOR_ARR = [
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'a:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
];

export default function useFocusWithDelay (focusItem, delay = 100) {
    const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
    const doFocusDelay = async () => {
        await sleep(delay).then(() => {if (focusItem) focusItem.focus();});

    };
    doFocusDelay();
}
